"use strict";

exports.__esModule = true;
exports.ReportWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _EditableReportElement = require("./EditableReportElement");
var _ReportElement = require("./ReportElement");
var _ReportFields = require("./ReportFields");
var _ReportHeader = require("./ReportHeader");
var _ReportWidgetThumbnail = require("./ReportWidgetThumbnail");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ReportWidget = exports.ReportWidget = {
  name: "Report",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "ReportWidget.label",
    defaultMessage: "Report"
  }),
  icon: "report",
  ignoreHeading: true,
  createElement: function createElement(props) {
    return {
      type: "Report",
      props: Object.assign({
        width: 1024,
        height: 768,
        rowCount: 12,
        columnCount: 12
      }, props),
      children: []
    };
  },
  showInPalette: false,
  isParent: true,
  requiresContexts: [],
  suppliesContexts: ["devices"],
  optionalProps: [],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: ["x", "y", "width", "height"],
  propConstraints: {
    width: {
      "default": 1024,
      min: 128,
      max: 3840
    },
    height: {
      "default": 768,
      min: 128,
      max: 2160
    }
  },
  components: {
    Header: _ReportHeader.ReportHeader,
    Element: _ReportElement.ReportElement,
    Fields: _ReportFields.ReportFields,
    Editable: _EditableReportElement.EditableReportElement,
    Thumbnail: _ReportWidgetThumbnail.ReportWidgetThumbnail
  }
};